import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from '@custom-components';
import FeatureFlagOrgTable from './FeatureFlagOrgTable';
import FeatureFlagOrgsContainer from './FeatureFlagOrgsContainer';

import List from '../List';

const featureOrgsViewFilters = [
  {
    id: 'ALL_ORGS_VIEW',
    label: 'All Orgs',
    filterFn: () => true
  },
  {
    id: 'ACTIVE_Organizations',
    label: 'Active Organizations',
    filterFn: (item) => item.active === true
  },
  {
    id: 'INACTIVE_Organizations',
    label: 'Inactive Organizations',
    filterFn: (item) => item.active === false
  }
];

const featureOrgsSortFilters = [
  {
    id: 'NO_FILTER',
    label: 'No Filter'
  }
];

function FeatureFlagOrgsList(props) {
  const { loading, feature, updateList } = props;
  return (
    <Grid.ScreenClassRender
      render={(screenClass) => (
        <FeatureFlagOrgsContainer>
          {({
            pagination,
            search,
            sortBy,
            toggle,
            view,
            updatePagination,
            updateSearch,
            updateSortBy,
            updateToggle,
            updateView,
            activateFeatureFlagMapping
          }) => (
            <List
              initialPaginationValue={pagination}
              initialQueryValue={search}
              initialSortFilterId={sortBy}
              initialToggleValue={toggle}
              initialViewFilterId={view}
              data={feature.organizationMappings}
              loading={loading}
              viewFilters={featureOrgsViewFilters}
              sortFilters={featureOrgsSortFilters}
              screenClass={screenClass}
              tableComponent={FeatureFlagOrgTable}
              mutations={{ activateFeatureFlagMapping, updateList }}
              helpText="Search by organization name or email"
              noDataObj={{
                message: 'There are no organization mappings for that search, or no mappings have been created',
                title: 'No Organizations'
              }}
              searchBy={['organization.name', 'organization.emailAddress']}
              listComponentProps={{
                defaultView: 'tableView',
                interactionHooks: {
                  onPaginationChange: (p) => updatePagination(p),
                  onSearchChange: (s) => updateSearch(s),
                  onSortFilterClick: (s) => updateSortBy(s.id),
                  onViewFilterClick: (v) => updateView(v.id),
                  onViewToggleClick: (t) => updateToggle(t)
                }
              }}
            />
          )}
        </FeatureFlagOrgsContainer>
      )}
    />
  );
}

FeatureFlagOrgsList.propTypes = {
  loading: PropTypes.bool,
  feature: PropTypes.shape({
    organizationMappings: PropTypes.arrayOf(PropTypes.shape({})).isRequired
  }).isRequired,
  updateList: PropTypes.func.isRequired,
  error: PropTypes.shape({})
};

FeatureFlagOrgsList.defaultProps = {
  loading: true,
  error: null
};

export default FeatureFlagOrgsList;
